import communicationLinesFa from './fa/fa.json'

const communicationLinesMessages = {
  fa: { ...communicationLinesFa },
}

export default communicationLinesMessages
